import {
  updateInteractability,
  updateMultipleInteractability,
  useDataTemplate,
} from 'components/form_builder/features/data/dataSlice'
import { isEqual } from 'lodash'
import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ConditionalControls from '../ConditionalControls'
import SectionDivider from '../SectionDivider'
import { OverrideWarning } from './PathForMultipleFields'

export const MultipleInteractability = ({ shareComponent, components }) => {
  const dispatch = useDispatch()
  const { type, id } = shareComponent

  const data = useSelector((state) => state.data)
  const commonInteractable = data[type]?.[id]?.interactable

  const isUniform = useMemo(() => {
    if (!components || components.length === 0) return true

    return components.slice(1).every((component) => {
      const { type, id } = component
      const interactable = data[type]?.[id]?.interactable
      if (typeof commonInteractable === 'boolean') return interactable === commonInteractable
      return isEqual(interactable, commonInteractable)
    })
  }, [components, commonInteractable, data])

  const handleUpdate = (interactability) => dispatch(updateMultipleInteractability({ components, interactability }))

  return (
    <SectionDivider sectionName="interactability">
      {!isUniform ? (
        <OverrideWarning onOverride={() => handleUpdate(true)} />
      ) : (
        <ConditionalControls initialValue={commonInteractable} onUpdate={handleUpdate} />
      )}
    </SectionDivider>
  )
}

export default function Interactability({ component }) {
  const dispatch = useDispatch()
  const { type, id } = component
  const template = useDataTemplate(type, id)

  const handleUpdate = (interactability) => dispatch(updateInteractability({ id, type, interactability }))

  return (
    <SectionDivider sectionName="interactability">
      <ConditionalControls initialValue={template.interactable} onUpdate={handleUpdate} />
    </SectionDivider>
  )
}
